import { Form as BaseForm } from '@sketch/components'
import styled from 'styled-components'

export const Form = styled(BaseForm)`
  width: 100%;
  max-width: 410px;
`
